import axios from 'axios';

// Base configuration for API calls
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000, // Increase timeout to 30 seconds for complex queries
  withCredentials: true, // Enable cookies for session authentication
});

// Request interceptor to add CSRF token and handle auth
apiClient.interceptors.request.use(
  (config) => {
    // Add CSRF token if available
    const csrfToken = localStorage.getItem('csrfToken');
    if (csrfToken) {
      config.headers['X-CSRFToken'] = csrfToken;
      console.log('CSRF Token enviado:', csrfToken);
    } else {
      console.warn('No se encontró CSRF token en localStorage');
    }
    
    console.log('Headers de la petición:', config.headers);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle authentication errors
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Clear local storage on auth failure
      localStorage.removeItem('user');
      localStorage.removeItem('csrfToken');
      
      // Redirect to login if not already there
      if (window.location.pathname !== '/login') {
        window.location.reload();
      }
    }
    
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export default apiClient;